import { cx } from "#ui/style.utils";

interface LayoutOneFourthProps extends Omit<
  React.ComponentPropsWithoutRef<"div">,
  "slot"
> {
  reverse?: boolean;
  slot: React.ReactNode;
}

/**
 * Usage: `<LayoutOneFourth slot={...}>...</LayoutOneFourth>`
 *
 * Stacked on mobile, columnized upwards (tablet: 3-col, desktop: 4-col).
 *
 * @param props.children - Used for the large column.
 * @param props.slot - Used for the small column.
 * @param props.reverse - Swaps display (not render) order. Default: `false`
 */
export function LayoutOneFourth({
  children,
  className,
  reverse = false,
  slot,
  ...props
}: LayoutOneFourthProps) {
  return (
    <div
      {...props}
      className={cx(
        "grid gap-20px",
        "md:grid-cols-3",
        "lg:grid-cols-4 lg:gap-30px",
        className,
      )}
    >
      <div
        className={cx(
          "md:col-span-2 md:row-start-1 lg:col-span-3",
          reverse ? "md:col-start-1" : "md:col-start-2",
        )}
      >
        {children}
      </div>
      <div
        className={cx(
          "row-start-1 md:col-span-1",
          reverse ? "md:col-start-3 lg:col-start-4" : "md:col-start-1",
        )}
      >
        {slot}
      </div>
    </div>
  );
}
